<template>
  <div>
    <div class="title-popup-s">스케줄 실행 요일</div>
    <el-radio-group style="margin-bottom: 20px;" v-model="weeklyData.SCHEDULE_INTERVAL_DATE">
      <el-radio-button v-for="day in WEEK" :key="day.week" :label="(day.week+1).toString()">{{day.label}}</el-radio-button>
    </el-radio-group>
    <w-time-selection-component ref="weeklyTime" title="실행 시간" :executeHour="weeklyData.scheduleHour" :executeMinute="weeklyData.scheduleMinute" />
  </div>
</template>

<script>
import keys from 'lodash/keys';
import clone from 'lodash/clone';
import { PERIODTYPE, LASTDAY } from '@/constants/schedule';
import { WEEK, MONTH } from '@/constants/date';
import WTimeSelectionComponent from '@/views/settings/components/TimeSelectionComponent';

const weeklyInitData = {
  SCHEDULE_INTERVAL_DATE: '1',
  scheduleHour: 0,
  scheduleMinute: 0,
};

export default {
  name: 'WPredictAnalysisPeriodSettingComponent',
  components: {
    WTimeSelectionComponent,
  },
  data() {
    return {
      PERIODTYPE,
      LASTDAY,
      WEEK,
      MONTH,
      period: PERIODTYPE.WEEKLY,
      onceData: {},
      dailyData: {},
      weeklyData: {},
      monthlyData: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.period = PERIODTYPE.WEEKLY;
      this.weeklyData = clone(weeklyInitData);
      this.$refs.weeklyTime.init();
    },
    /**
     * 주기 설정 데이터를 리턴한다.
     */
    getPeriodSettingData() {
      let settingData = {};
      const selectionTime = this.$refs.weeklyTime.getSelectionTime();

      settingData = {
        SCHEDULE_PERIOD: PERIODTYPE.WEEKLY,
        SCHEDULE_INTERVAL_DATE: this.weeklyData.SCHEDULE_INTERVAL_DATE,
        SCHEDULE_HOUR: selectionTime.hour,
        SCHEDULE_MINUTE: selectionTime.minute,
      };
      return settingData;
    },
    /**
     * 수집 주기 편집에서 주기 설정 데이터를 바인딩한다.
     */
    setPeriodSettingData(record) {
      const schedulePeriod = record.SCHEDULE_PERIOD;
      this.period = schedulePeriod;

      if (schedulePeriod === PERIODTYPE.WEEKLY) {
        this.weeklyData = {
          SCHEDULE_INTERVAL_DATE: record.SCHEDULE_INTERVAL_DATE,
          scheduleHour: Number(record.SCHEDULE_HOUR),
          scheduleMinute: Number(record.SCHEDULE_MINUTE),
        };
      }
    },
    /**
     * 주기에 해당하는 각 key들을 리턴한다.
     * 수집 주기 편집시 사용.
     */
    getKeysByPeriod() {
      return keys(this.weeklyData);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/event/components/PredictAnalysisPeriodSettingComponent.vue